// 閾値超過履歴
export type AlertHistoryAttributes = {
  thresholdId: string
  title: string
  level: number
  comparison: number
  record: number
  status: string
  target: string
  startTime: string
  endTime: string
}

export default class AlertHistory {
  public thresholdId: string
  public title: string
  public level: number
  public comparison: number
  public record: number
  public status: string
  public target: string
  public startTime: string
  public endTime: string

  constructor(public attributes: AlertHistoryAttributes) {
    this.thresholdId = attributes.thresholdId
    this.title = attributes.title
    this.level = attributes.level
    this.comparison = attributes.comparison
    this.record = attributes.record
    this.status = attributes.status
    this.target = attributes.target
    this.startTime = attributes.startTime
    this.endTime = attributes.endTime
  }
}
